import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RedirectCommand, Router } from '@angular/router';
import { ConnectTypeModalComponent } from '../modals/connect-type-modal/connect-type-modal.component';
import { ServiceFeatures } from '../models/serviceFeatures';
import { SessionService } from '../services/session.service';
import { ProductsService } from '../services/products.service';
import { MatDialog } from '@angular/material/dialog';

let openedModal: boolean = false;

const openConnectionTypeModal = () => {
	const dialog: MatDialog = inject(MatDialog);

	if (openedModal) return;
	openedModal = true;
	const dialogRef = dialog.open(ConnectTypeModalComponent, {
		width: '900px',
		autoFocus: false,
		backdropClass: 'back-drop',
		panelClass: 'scrollable-content',
		disableClose: true
	});
	dialogRef.afterClosed().subscribe(() => openedModal = false);
}

export const emptyAssortmentGuard = (route: ActivatedRouteSnapshot) => {
	const sessionService: SessionService = inject(SessionService);
	const productsService: ProductsService = inject(ProductsService);
	const router: Router = inject(Router);

	if (sessionService.hasFeature(ServiceFeatures.LoadAssortment) && productsService.isEmptyAssortment) {
		openConnectionTypeModal();

		if (route.data?.isProduct) return true;

		return new RedirectCommand(
			router.createUrlTree(sessionService.getLink(['product'])),
			{ replaceUrl: true, skipLocationChange: false }
		);
	} else {
		return true;
	}
}
